<template>
  <div>
    <div class="marginCenter">
      <el-form
        :model="form.applyBasic"
        :rules="rules"
        label-position="left"
        class="form marginTop30"
      >
        <!-- 其他信息 -->
        <div class="marginBom30">
          <div class="fsize24 fcolor_black marginBom18">其他信息</div>
          <div class="content fsize22">
            进修报到一般在每月第2个工作日，具体以《进修报到通知单》为准。因报到、岗前培训需多部门协作，故请进修人员务必在进修报到日当天报到。
          </div>
        </div>
        <!-- 进修内容与目标 -->
        <div class="marginBom38 title">
          <el-form-item prop="trainRequest" label="进修内容与目标">
            <el-input
              class="marginTop24"
              type="textarea"
              :rows="2"
              :maxlength="500"
              :show-word-limit="true"
              placeholder="请输入内容"
              v-model="form.applyBasic.trainRequest"
            ></el-input>
          </el-form-item>
          <!-- <div class="fsize22 fcolor_black marginBom24">进修内容与目标</div>
          <div class="content">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.applyBasic.trainRequest">
            </el-input>
          </div>-->
        </div>
        <!-- 申请进修科室 -->
        <div class="marginBom38">
          <div class="fsize22 contentTitle1 flex-yCenter marginBom24">
            <span class="fcolor_black required">申请进修科室</span>
            <el-button class="btn" type="primary" @click="showAddStudyDept"
              >新增</el-button
            >
          </div>
          <div class="content">
            <el-table border :data="form.applyDeptList" style="width: 100%">
              <el-table-column
                prop="deptName"
                label="进修科室"
                min-width="150"
                align="center"
              >
                <span v-if="deptList" slot-scope="scope">
                  <span
                    v-if="
                      deptList.filter((item) => item.deptId == scope.row.deptId).length >
                      0
                    "
                  >
                    {{
                      deptList.filter((item) => item.deptId == scope.row.deptId)[0]
                        .deptName
                    }}
                  </span>
                  <span v-else class="fcolor_red">该科室已被删除，请重新选择科室</span>
                </span>
              </el-table-column>
              <el-table-column
                label="进修方向"
                min-width="150"
                align="center"
              >
                <span slot-scope="scope">
                  {{
                    Array.isArray(scope.row.trainDirection)
                      ? scope.row.trainDirection.join("、")
                      : scope.row.trainDirection
                  }}
                </span>
              </el-table-column>
              <el-table-column
                prop="beginDate"
                label="希望进修开始时间"
                min-width="150"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="endDate"
                label="希望进修结束时间"
                min-width="150"
                align="center"
              ></el-table-column>
              <el-table-column label="进修时长" min-width="130" align="center">
                <span slot-scope="scope">{{ scope.row.trainDuration }}个月</span>
              </el-table-column>
              <el-table-column
                prop="intentionTeacher"
                label="意向带教老师"
                min-width="150"
                align="center"
              ></el-table-column>
              <el-table-column min-width="150" label="操作" align="center">
                <template slot-scope="scope">
                  <div>
                    <el-button type="text" @click="showModifyStudyDept(scope.row)"
                      >修改</el-button
                    >
                    <el-button type="text" @click="removeStudyDept(scope.row)"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="flex-sb">
          <div>
            <div class="fsize22 contentTitle1 flex-yCenter marginBom24">
              <span class="fcolor_black required">是否同期报名平台培训项目</span>
            </div>
            <el-select
              v-model="isSpecialItems"
              :clearable="false"
              placeholder="请选择"
              style="width: 500px"
              @change="form.applyBasic.specialItems = ''"
            >
              <el-option
                v-for="item in [
                  { label: '是', value: 1 },
                  { label: '否', value: 0 },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div style="color: #ff0000; font-size: 16px">
              (请查看首页《临床学习培训项目》自我对照)
            </div>
          </div>
          <div>
            <template v-if="isSpecialItems == 1">
              <div class="fsize22 contentTitle1 flex-yCenter marginBom24">
                <span class="fcolor_black required">特殊培训项目</span>
              </div>
              <el-select
                v-model="form.applyBasic.specialItems"
                @change="
                  () => {
                    $set(form.applyBasic, 'specialItemsOther', '');
                    $forceUpdate();
                  }
                "
                clearable
                placeholder="请选择"
                style="width: 500px"
              >
                <el-option
                  v-for="item in dict.type.special_items"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </div>
        </div>
        <div v-if="isSpecialItems == 1" class="marginBom30">
          <template
            v-if="
              dict.type.special_items.filter(
                (item) => item.value == form.applyBasic.specialItems
              ).length > 0 &&
              dict.type.special_items.filter(
                (item) => item.value == form.applyBasic.specialItems
              )[0].raw.remark == 'other'
            "
          >
            <div class="fsize22 contentTitle1 flex-yCenter marginBom24">
              <span class="fcolor_black required">其他补充项目</span>
            </div>
            <el-input
              v-model="form.applyBasic.specialItemsOther"
              @change="() => $forceUpdate()"
            ></el-input>
          </template>
        </div>
        <div class="overflow staging marginBom30">
          <el-button class="fr blueBtn2 btn300" @click="staging" type="primary"
            >保存此页信息</el-button
          >
        </div>
        <div class="footer fr flex-yCenter">
          <a class="a backIndex fcolor_blue2 fsize22" @click="$parent.active = 2">1</a>
          <a class="a backIndex active fcolor_blue2 fsize22" @click="$parent.active = 3"
            >2</a
          >
          <a class="a backIndex fcolor_blue2 fsize22" @click="$parent.active = 4">3</a>
          <a class="a backIndex fcolor_blue2 fsize22" @click="$parent.active = 4"
            >下一页</a
          >
        </div>
      </el-form>
    </div>
    <!-- 新增进修科室 -->
    <Modal
      :showState="addStudyDeptState"
      @cancel="addStudyDeptCancel"
      title="新增"
      @confirm="addStudyDeptConfirm"
    >
      <template #content>
        <el-form
          ref="addStudyDept"
          :rules="addStudyDeptRules"
          inline
          :model="addStudyDeptForm"
          label-position="right"
          label-width="120px"
        >
          <div>
            <el-form-item
              style="display: flex !important"
              prop="beginDate"
              label="开始日期："
            >
              <el-date-picker
                v-model="addStudyDeptForm.beginDate"
                @change="addDateChange"
                format="yyyy-MM"
                value-format="yyyy-MM"
                type="month"
                style="width: 100%"
                :clearable="false"
                :picker-options="addBeginDisabled"
              ></el-date-picker>
              <div class="fcolor_gray" style="line-height: inherit">
                （进修开始时间为每月的第一天）
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: flex !important"
              prop="endDate"
              label="结束日期："
            >
              <el-date-picker
                v-model="addStudyDeptForm.endDate"
                @change="addDateChange"
                format="yyyy-MM"
                value-format="yyyy-MM"
                type="month"
                style="width: 100%"
                :clearable="false"
                :picker-options="addEndDisabled"
              ></el-date-picker>
              <div class="fcolor_gray" style="line-height: inherit">
                （进修结束时间为每月的最后一天）
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: flex !important"
              prop="deptId"
              label="进修科室："
            >
              <el-select
                v-model="addStudyDeptForm.deptId"
                filterable
                placeholder="请选择"
                style="width: 100%"
                @change="addDeptChange"
              >
                <el-option
                  v-for="item in deptList"
                  :key="item.deptId"
                  :label="item.deptName"
                  :value="item.deptId"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: flex !important"
              prop="trainDuration"
              label="进修时长："
            >
              <el-select
                v-model="addStudyDeptForm.trainDuration"
                disabled
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in ['1', '2', '3', '4', '6', '9', '12', '24']"
                  :key="index"
                  :label="item + '个月'"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: flex !important"
              prop="intentionTeacher"
              label="意向带教老师："
            >
              <el-input
                v-model="addStudyDeptForm.intentionTeacher"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: flex !important"
              prop="trainDirection"
              label="进修方向："
            >
              <el-select
                ref="addTrainDirectionSelect"
                v-model="addStudyDeptForm.trainDirection"
                multiple
                clearable
                filterable
                allow-create
                default-first-option
                placeholder="请先选择进修科室"
                style="width: 100%"
                :disabled="!addStudyDeptForm.deptId"
                @change="addDirectionChange"
              >
                <el-option
                  v-for="item in addDirectionList"
                  :key="item.directionId"
                  :label="item.directionName"
                  :value="item.directionName"
                ></el-option>
                <el-option label="其他（手动填写）" value="__OTHER__"></el-option>
              </el-select>
            </el-form-item>
            <div v-if="showAddOtherInput" class="other-input-line">
              <el-input
                ref="addOtherInput"
                v-model="addOtherValue"
                placeholder="请输入其他进修方向"
              ></el-input>
              <el-button type="primary" @click="addOtherConfirm">确定</el-button>
            </div>
          </div>
        </el-form>
      </template>
    </Modal>
    <!-- 修改进修科室 -->
    <Modal
      :showState="modifyStudyDeptState"
      @cancel="modifyStudyDeptCancel"
      title="修改"
      @confirm="modifyStudyDeptConfirm"
    >
      <template #content>
        <el-form
          ref="modifyStudyDept"
          :rules="modifyStudyDeptRules"
          inline
          :model="modifyStudyDeptForm"
          label-position="right"
          label-width="120px"
        >
          <div>
            <el-form-item
              style="display: flex !important"
              prop="beginDate"
              label="开始日期："
            >
              <el-date-picker
                v-model="modifyStudyDeptForm.beginDate"
                @change="modifyDateChange"
                format="yyyy-MM"
                value-format="yyyy-MM"
                type="month"
                style="width: 100%"
                :clearable="false"
                :picker-options="modifyBeginDisabled"
              ></el-date-picker>
              <div class="fcolor_gray" style="line-height: inherit">
                进修开始时间为每月的第一天
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: flex !important"
              prop="endDate"
              label="结束日期："
            >
              <el-date-picker
                v-model="modifyStudyDeptForm.endDate"
                @change="modifyDateChange"
                format="yyyy-MM"
                value-format="yyyy-MM"
                type="month"
                style="width: 100%"
                :clearable="false"
                :picker-options="modifyEndDisabled"
              ></el-date-picker>
              <div class="fcolor_gray" style="line-height: inherit">
                进修结束时间为每月的最后一天
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: flex !important"
              prop="deptId"
              label="进修科室："
            >
              <el-select
                v-model="modifyStudyDeptForm.deptId"
                filterable
                placeholder="请选择"
                style="width: 100%"
                @change="modifyDeptChange"
              >
                <el-option
                  v-for="item in deptList"
                  :key="item.deptId"
                  :label="item.deptName"
                  :value="item.deptId"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: flex !important"
              prop="trainDuration"
              label="进修时长："
            >
              <el-select
                v-model="modifyStudyDeptForm.trainDuration"
                disabled
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in ['1', '2', '3', '4', '6', '9', '12', '24']"
                  :key="index"
                  :label="item + '个月'"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: flex !important"
              prop="intentionTeacher"
              label="意向带教老师："
            >
              <el-input
                v-model="modifyStudyDeptForm.intentionTeacher"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              style="display: flex !important"
              prop="trainDirection"
              label="进修方向："
            >
              <el-select
                ref="modifyTrainDirectionSelect"
                v-model="modifyStudyDeptForm.trainDirection"
                multiple
                clearable
                filterable
                default-first-option
                placeholder="请先选择进修科室"
                style="width: 100%"
                :disabled="!modifyStudyDeptForm.deptId"
                @change="modifyDirectionChange"
              >
                <el-option
                  v-for="item in modifyDirectionList"
                  :key="item.directionId"
                  :label="item.directionName"
                  :value="item.directionName"
                ></el-option>
                <el-option label="其他（手动填写）" value="__OTHER__"></el-option>
              </el-select>
            </el-form-item>
            <div v-if="showModifyOtherInput" class="other-input-line">
              <el-input
                ref="modifyOtherInput"
                v-model="modifyOtherValue"
                placeholder="请输入其他进修方向"
              ></el-input>
              <el-button type="primary" @click="modifyOtherConfirm">确定</el-button>
            </div>
          </div>
        </el-form>
      </template>
    </Modal>
  </div>
</template>
<script>
import { getToken } from "@/utils/auth";
import { getApplyStorage, stagingApplyStorage, getDeptList, getDeptDirectionList } from "@/utils/api";
import { getCurrentMonthFirst, getLastDay } from "@/utils/myUtil";
import { parseTime } from "@/utils/ruoyi";
import Modal from "@/views/components/modal.vue";
import { v4 as uuidv4 } from "uuid";
export default {
  dicts: ["special_items"],
  components: {
    Modal,
  },
  data() {
    return {
      form: {
        trainType: this.$route.query.type,
        // 申请信息
        applyBasic: {
          specialItemsOther: "",
        },
        // 进修科室
        applyDeptList: [],
        // 附件
        applyAttList: [],
      },
      isSpecialItems: 0,
      headers: {
        Authorization: "Bearer " + getToken(),
      },
      // 新增进修科室显示状态
      addStudyDeptState: false,
      // 新增进修科室表单
      addStudyDeptForm: {
        beginDate: "",
        endDate: "",
        deptId: "",
        trainDuration: "",
        trainDirection: [],
        trainDirectionId: [],
        intentionTeacher: "",
      },
      // 新增进修科室表单校验
      addStudyDeptRules: {
        beginDate: [{ required: true, trigger: "change", message: "开始日期不能为空" }],
        endDate: [{ required: true, trigger: "change", message: "结束日期不能为空" }],
        deptId: [{ required: true, trigger: "change", message: "进修科室不能为空" }],
        trainDuration: [
          { required: true, trigger: "change", message: "进修时长不能为空" },
        ],
        trainDirection: {
          required: true,
          trigger: ["blur", "change"],
          message: "进修方向不能为空",
        },
      },
      // 修改进修科室显示状态
      modifyStudyDeptState: false,
      // 修改进修科室表单
      modifyStudyDeptForm: {},
      // 修改进修科室表单校验
      modifyStudyDeptRules: {
        beginDate: [{ required: true, trigger: "change", message: "开始日期不能为空" }],
        endDate: [{ required: true, trigger: "change", message: "结束日期不能为空" }],
        deptId: [{ required: true, trigger: "change", message: "进修科室不能为空" }],
        trainDuration: [
          { required: true, trigger: "change", message: "进修时长不能为空" },
        ],
        trainDirection: {
          required: true,
          trigger: ["blur", "change"],
          message: "进修方向不能为空",
        },
      },
      // 科室列表
      deptList: [],
      // 新增进修科室-进修方向列表
      addDirectionList: [],
      // 修改进修科室-进修方向列表
      modifyDirectionList: [],
      // 新增进修科室-其他进修方向输入
      showAddOtherInput: false,
      addOtherValue: "",
      // 修改进修科室-其他进修方向输入
      showModifyOtherInput: false,
      modifyOtherValue: "",
      // 上传文件类型
      uploadType: "",
      rules: {
        trainRequest: {
          required: true,
          trigger: "blur",
          message: "进修内容与目标不能为空",
        },
      },
    };
  },
  computed: {
    addBeginDisabled() {
      let that = this;
      return {
        disabledDate(time) {
          let newDate = new Date();
          let endDate = new Date(that.addStudyDeptForm.endDate);
          if (that.addStudyDeptForm.endDate) {
            if (
              time.getFullYear() > newDate.getFullYear() &&
              time.getFullYear() < endDate.getFullYear()
            ) {
              return false;
            } else if (
              time.getFullYear() < newDate.getFullYear() ||
              time.getFullYear() > endDate.getFullYear()
            ) {
              return true;
            } else if (
              time.getFullYear() == newDate.getFullYear() &&
              time.getFullYear() == endDate.getFullYear()
            ) {
              if (
                time.getMonth() > newDate.getMonth() &&
                time.getMonth() <= endDate.getMonth()
              ) {
                return false;
              } else {
                return true;
              }
            } else if (
              time.getFullYear() == newDate.getFullYear() &&
              time.getFullYear() != endDate.getFullYear()
            ) {
              if (time.getMonth() > newDate.getMonth()) {
                return false;
              } else {
                return true;
              }
            } else {
              if (time.getMonth() <= endDate.getMonth()) {
                return false;
              } else {
                return true;
              }
            }
          } else {
            if (time.getFullYear() > newDate.getFullYear()) {
              return false;
            } else if (time.getFullYear() < newDate.getFullYear()) {
              return true;
            } else {
              if (time.getMonth() > newDate.getMonth()) {
                return false;
              } else {
                return true;
              }
            }
          }
        },
      };
    },
    addEndDisabled() {
      let that = this;
      return {
        disabledDate(time) {
          let newDate = new Date();
          let beginDate = new Date(that.addStudyDeptForm.beginDate);
          if (that.addStudyDeptForm.beginDate) {
            if (
              time.getFullYear() > newDate.getFullYear() &&
              time.getFullYear() > beginDate.getFullYear()
            ) {
              return false;
            } else if (
              time.getFullYear() < newDate.getFullYear() ||
              time.getFullYear() < beginDate.getFullYear()
            ) {
              return true;
            } else if (
              time.getFullYear() == newDate.getFullYear() &&
              time.getFullYear() == beginDate.getFullYear()
            ) {
              if (
                time.getMonth() > newDate.getMonth() &&
                time.getMonth() >= beginDate.getMonth()
              ) {
                return false;
              } else {
                return true;
              }
            } else if (
              time.getFullYear() == newDate.getFullYear() &&
              time.getFullYear() != beginDate.getFullYear()
            ) {
              if (time.getMonth() > newDate.getMonth()) {
                return false;
              } else {
                return true;
              }
            } else {
              if (time.getMonth() >= beginDate.getMonth()) {
                return false;
              } else {
                return true;
              }
            }
          } else {
            if (time.getFullYear() > newDate.getFullYear()) {
              return false;
            } else if (time.getFullYear() < newDate.getFullYear()) {
              return true;
            } else {
              if (time.getMonth() > newDate.getMonth()) {
                return false;
              } else {
                return true;
              }
            }
          }
        },
      };
    },
    modifyBeginDisabled() {
      let that = this;
      return {
        disabledDate(time) {
          let newDate = new Date();
          let endDate = new Date(that.modifyStudyDeptForm.endDate);
          if (that.modifyStudyDeptForm.endDate) {
            if (
              time.getFullYear() > newDate.getFullYear()
              // && time.getFullYear() < endDate.getFullYear()
            ) {
              return false;
            } else if (
              time.getFullYear() < newDate.getFullYear()
              //|| time.getFullYear() > endDate.getFullYear()
            ) {
              return true;
            } else if (
              time.getFullYear() == newDate.getFullYear()
              //  && time.getFullYear() == endDate.getFullYear()
            ) {
              if (
                time.getMonth() > newDate.getMonth()
                // && time.getMonth() <= endDate.getMonth()
              ) {
                return false;
              } else {
                return true;
              }
            } else if (
              time.getFullYear() == newDate.getFullYear() &&
              time.getFullYear() != endDate.getFullYear()
            ) {
              if (time.getMonth() > newDate.getMonth()) {
                return false;
              } else {
                return true;
              }
            } else {
              if (time.getMonth() <= endDate.getMonth()) {
                return false;
              } else {
                return true;
              }
            }
          } else {
            if (time.getFullYear() > newDate.getFullYear()) {
              return false;
            } else if (time.getFullYear() < newDate.getFullYear()) {
              return true;
            } else {
              if (time.getMonth() > newDate.getMonth()) {
                return false;
              } else {
                return true;
              }
            }
          }
        },
      };
    },
    modifyEndDisabled() {
      let that = this;
      return {
        disabledDate(time) {
          let newDate = new Date();
          let beginDate = new Date(that.modifyStudyDeptForm.beginDate);
          if (that.modifyStudyDeptForm.beginDate) {
            if (
              time.getFullYear() > newDate.getFullYear() &&
              time.getFullYear() > beginDate.getFullYear()
            ) {
              return false;
            } else if (
              time.getFullYear() < newDate.getFullYear() ||
              time.getFullYear() < beginDate.getFullYear()
            ) {
              return true;
            } else if (
              time.getFullYear() == newDate.getFullYear() &&
              time.getFullYear() == beginDate.getFullYear()
            ) {
              if (
                time.getMonth() > newDate.getMonth() &&
                time.getMonth() >= beginDate.getMonth()
              ) {
                return false;
              } else {
                return true;
              }
            } else if (
              time.getFullYear() == newDate.getFullYear() &&
              time.getFullYear() != beginDate.getFullYear()
            ) {
              if (time.getMonth() > newDate.getMonth()) {
                return false;
              } else {
                return true;
              }
            } else {
              if (time.getMonth() >= beginDate.getMonth()) {
                return false;
              } else {
                return true;
              }
            }
          } else {
            if (time.getFullYear() > newDate.getFullYear()) {
              return false;
            } else if (time.getFullYear() < newDate.getFullYear()) {
              return true;
            } else {
              if (time.getMonth() > newDate.getMonth()) {
                return false;
              } else {
                return true;
              }
            }
          }
        },
      };
    },
  },
  created() {
    this.form = this.$parent.form;
    this.form.applyBasic.specialItems
      ? (this.isSpecialItems = 1)
      : (this.isSpecialItems = 0);
    this.form.applyDeptList.forEach((item) => {
      item.uuid = uuidv4();
    });
    this._getDeptList();
  },
  mounted() {},
  methods: {
    _getDeptList() {
      // 获取科室列表
      getDeptList({ deptTrainType: "0" }).then((res) => {
        this.deptList = res.data;
      });
    },
    // 获取科室对应的进修方向列表
    _getDeptDirectionList(deptId, listKey) {
      if (!deptId) {
        this[listKey] = [];
        return;
      }
      getDeptDirectionList(deptId).then((res) => {
        this[listKey] = res.data || [];
      });
    },
    // 新增——选择进修科室后动态加载进修方向
    addDeptChange(deptId) {
      this.$set(this.addStudyDeptForm, "trainDirection", []);
      this.$set(this.addStudyDeptForm, "trainDirectionId", []);
      this._getDeptDirectionList(deptId, "addDirectionList");
    },
    // 修改——选择进修科室后动态加载进修方向
    modifyDeptChange(deptId) {
      this.$set(this.modifyStudyDeptForm, "trainDirection", []);
      this.$set(this.modifyStudyDeptForm, "trainDirectionId", []);
      this._getDeptDirectionList(deptId, "modifyDirectionList");
    },
    // 记录所选进修方向的 id（trainDirection 存名称数组用于展示，支持自定义输入）
    addDirectionChange(val) {
      const names = Array.isArray(val) ? val : [];
      // 选中“其他（手动填写）”时：移除标记项并展开输入框
      if (names.includes("__OTHER__")) {
        this.$set(
          this.addStudyDeptForm,
          "trainDirection",
          names.filter((n) => n !== "__OTHER__")
        );
        this.addOtherValue = "";
        this.showAddOtherInput = true;
        this.$nextTick(() => {
          this.$refs.addTrainDirectionSelect &&
            this.$refs.addTrainDirectionSelect.blur();
          this.$refs.addOtherInput && this.$refs.addOtherInput.focus();
        });
      }
      this.$set(
        this.addStudyDeptForm,
        "trainDirectionId",
        this.addDirectionList
          .filter((d) => names.includes(d.directionName))
          .map((d) => d.directionId)
      );
    },
    modifyDirectionChange(val) {
      const names = Array.isArray(val) ? val : [];
      // 选中“其他（手动填写）”时：移除标记项并展开输入框
      if (names.includes("__OTHER__")) {
        this.$set(
          this.modifyStudyDeptForm,
          "trainDirection",
          names.filter((n) => n !== "__OTHER__")
        );
        this.modifyOtherValue = "";
        this.showModifyOtherInput = true;
        this.$nextTick(() => {
          this.$refs.modifyTrainDirectionSelect &&
            this.$refs.modifyTrainDirectionSelect.blur();
          this.$refs.modifyOtherInput && this.$refs.modifyOtherInput.focus();
        });
      }
      this.$set(
        this.modifyStudyDeptForm,
        "trainDirectionId",
        this.modifyDirectionList
          .filter((d) => names.includes(d.directionName))
          .map((d) => d.directionId)
      );
    },
    // 新增——确认“其他”进修方向
    addOtherConfirm() {
      const val = (this.addOtherValue || "").trim();
      if (!val) {
        this.$message.warning("请输入其他进修方向");
        return;
      }
      const list = Array.isArray(this.addStudyDeptForm.trainDirection)
        ? [...this.addStudyDeptForm.trainDirection]
        : [];
      if (!list.includes(val)) {
        list.push(val);
        this.$set(this.addStudyDeptForm, "trainDirection", list);
      }
      this.showAddOtherInput = false;
      this.addOtherValue = "";
      this.addDirectionChange(list);
    },
    // 修改——确认“其他”进修方向
    modifyOtherConfirm() {
      const val = (this.modifyOtherValue || "").trim();
      if (!val) {
        this.$message.warning("请输入其他进修方向");
        return;
      }
      const list = Array.isArray(this.modifyStudyDeptForm.trainDirection)
        ? [...this.modifyStudyDeptForm.trainDirection]
        : [];
      if (!list.includes(val)) {
        list.push(val);
        this.$set(this.modifyStudyDeptForm, "trainDirection", list);
      }
      this.showModifyOtherInput = false;
      this.modifyOtherValue = "";
      this.modifyDirectionChange(list);
    },
    // 输入格式：yyyy-MM-DD或yyyy-MM
    datemonth(date1, date2) {
      // 拆分年月日
      date1 = date1.split("-");
      // 得到月数
      date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
      // 拆分年月日
      date2 = date2.split("-");
      // 得到月数
      date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
      var m = Math.abs(date1 - date2); //Math.abs()取绝对值
      return m;
    },
    // 新增响应进修时间
    addDateChange(date) {
      if (this.addStudyDeptForm.beginDate && this.addStudyDeptForm.endDate) {
        this.addStudyDeptForm.trainDuration =
          this.datemonth(this.addStudyDeptForm.beginDate, this.addStudyDeptForm.endDate) +
          1 +
          "";
      }
    },
    modifyDateChange() {
      if (this.modifyStudyDeptForm.beginDate && this.modifyStudyDeptForm.endDate) {
        this.modifyStudyDeptForm.trainDuration =
          this.datemonth(
            this.modifyStudyDeptForm.beginDate,
            this.modifyStudyDeptForm.endDate
          ) +
          1 +
          "";
      }
    },
    // 打开新增进修科室
    showAddStudyDept() {
      this.showAddOtherInput = false;
      this.addOtherValue = "";
      this.addStudyDeptState = true;
    },
    // 确认新增进修科室
    addStudyDeptConfirm() {
      this.$refs.addStudyDept.validate((valid) => {
        if (valid) {
          // 新增并关闭弹窗
          let obj = {
            ...this.addStudyDeptForm,
            // 多选数组 → 逗号拼接字符串
            trainDirection: Array.isArray(this.addStudyDeptForm.trainDirection)
              ? this.addStudyDeptForm.trainDirection.join(",")
              : this.addStudyDeptForm.trainDirection || "",
            trainDirectionId: Array.isArray(this.addStudyDeptForm.trainDirectionId)
              ? this.addStudyDeptForm.trainDirectionId.join(",")
              : this.addStudyDeptForm.trainDirectionId || "",
            beginDate: getCurrentMonthFirst(new Date(this.addStudyDeptForm.beginDate)),
            endDate: getLastDay(new Date(this.addStudyDeptForm.endDate)),
            uuid: uuidv4(),
          };
          this.form.applyDeptList.push(obj);
          this.addStudyDeptCancel();
        }
      });
    },
    // 关闭新增进修科室
    addStudyDeptCancel() {
      // 注意：必须保留字段声明，直接置为 {} 会导致 trainDirection 等字段失去响应式
      this.addStudyDeptForm = {
        beginDate: "",
        endDate: "",
        deptId: "",
        trainDuration: "",
        trainDirection: [],
        trainDirectionId: [],
        intentionTeacher: "",
      };
      this.addDirectionList = [];
      this.showAddOtherInput = false;
      this.addOtherValue = "";
      this.addStudyDeptState = false;
      this.$refs.addStudyDept.resetFields();
    },
    // 删除进修科室
    removeStudyDept(obj) {
      let that = this;
      that
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.form.applyDeptList.forEach((item, index) => {
            if (item.uuid == obj.uuid) {
              that.form.applyDeptList.splice(index, 1);
            }
          });
        });
    },
    // 打开修改进修科室
    showModifyStudyDept(obj) {
      this.modifyStudyDeptState = true;
      this.showModifyOtherInput = false;
      this.modifyOtherValue = "";
      let form = JSON.parse(JSON.stringify(obj));
      // 兜底：确保字段存在，避免失去响应式导致下拉选不中
      form.deptId = form.deptId || "";
      // 兼容历史数据：字符串 → 数组
      if (typeof form.trainDirection === "string") {
        form.trainDirection = form.trainDirection
          ? form.trainDirection.split(/[,，、]/).filter((v) => v)
          : [];
      } else if (!Array.isArray(form.trainDirection)) {
        form.trainDirection = [];
      }
      form.trainDirectionId = Array.isArray(form.trainDirectionId)
        ? form.trainDirectionId
        : [];
      this.modifyStudyDeptForm = form;
      // 回显该科室已选的进修方向
      this._getDeptDirectionList(form.deptId, "modifyDirectionList");
    },
    // 修改进修科室确认
    modifyStudyDeptConfirm() {
      let that = this;
      this.form.applyDeptList.forEach((item, index) => {
        if (item.uuid == that.modifyStudyDeptForm.uuid) {
          let obj = {
            ...that.modifyStudyDeptForm,
            // 多选数组 → 逗号拼接字符串
            trainDirection: Array.isArray(that.modifyStudyDeptForm.trainDirection)
              ? that.modifyStudyDeptForm.trainDirection.join(",")
              : that.modifyStudyDeptForm.trainDirection || "",
            trainDirectionId: Array.isArray(that.modifyStudyDeptForm.trainDirectionId)
              ? that.modifyStudyDeptForm.trainDirectionId.join(",")
              : that.modifyStudyDeptForm.trainDirectionId || "",
            beginDate: getCurrentMonthFirst(new Date(this.modifyStudyDeptForm.beginDate)),
            endDate: getLastDay(new Date(this.modifyStudyDeptForm.endDate)),
          };
          that.$set(that.form.applyDeptList, index, obj);
          that.modifyStudyDeptCancel();
        }
      });
    },
    // 关闭修改进修科室
    modifyStudyDeptCancel() {
      this.modifyStudyDeptState = false;
      this.modifyDirectionList = [];
      this.showModifyOtherInput = false;
      this.modifyOtherValue = "";
    },
    // 保存此页信息
    staging() {
      stagingApplyStorage(this.form).then((res) => {
        if (res.code == 200) {
          this.$message.success("暂存信息成功");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .title .el-form-item__label {
  font-size: 22px;
  color: #333;
  padding: 0;
}

::v-deep .el-form-item__content {
  flex-grow: 1;
}

.el-button--primary {
  padding: 0;
}

.backIndex:hover {
  cursor: pointer;
}

.other-input-line {
  display: flex;
  align-items: center;
  margin: -8px 0 18px 120px;

  .el-input {
    flex: 1;
    margin-right: 10px;
  }

  .el-button {
    padding: 8px 16px;
  }
}

.formTitle {
  margin: 50px 0px 30px 240px;
}

.step {
  margin-bottom: 50px;
}

::v-deep .el-textarea__inner {
  height: 95px;
  font-size: 18px;
}

::v-deep.form {
  margin-bottom: 47px;
  overflow: hidden;

  .footer {
    .a {
      display: inline-block;
      width: 40px;
      line-height: 36px;
      text-align: center;
      border-radius: 5px;
      height: 40px;
      color: #333;
      border: #999999 solid 2px;
      margin-left: 30px;

      &:hover {
        border-color: #2d53c8;
      }
    }

    & > .a:last-child {
      width: 110px;
    }

    & > .active {
      border-color: #2d53c8;
    }
  }
}
</style>
